// extracted by mini-css-extract-plugin
export default {"root":"CircleImage_root__YZzYf","image":"CircleImage_image__T5KK4","small":"CircleImage_small__6aX9a","medium":"CircleImage_medium__K8Tc9","large":"CircleImage_large__Lxuwb"};